<template>
  <div class="feedback information">
    <p>{{ message }}</p>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'InvoiceSpecificationsResultMessage',
  data () {
    return {
      message: ''
    }
  },
  computed: {
    ...mapState({
      month: state => state.invoiceSpecifications.invoiceSpecificationsFilterInvoiceMonth,
      year: state => state.invoiceSpecifications.invoiceSpecificationsFilterInvoiceYear
    })
  },
  mounted () {
    this.setMessage()
  },
  methods: {
    setMessage: function () {
      this.message =
        this.$t('invoice.no-results-for-month-and-year', {month: this.getMonth(this.month), year: this.year})
      if (!(this.month || this.year)) {
        this.message = this.$t('generic.no-results')
      }
    },
    getMonth: function (value) {
      const months = {
        '1': this.$t('datepicker.months.january'),
        '2': this.$t('datepicker.months.february'),
        '3': this.$t('datepicker.months.march'),
        '4': this.$t('datepicker.months.april'),
        '5': this.$t('datepicker.months.may'),
        '6': this.$t('datepicker.months.june'),
        '7': this.$t('datepicker.months.july'),
        '8': this.$t('datepicker.months.august'),
        '9': this.$t('datepicker.months.september'),
        '10': this.$t('datepicker.months.october'),
        '11': this.$t('datepicker.months.november'),
        '12': this.$t('datepicker.months.december')
      }
      return value ? months[value] : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoiceSpecifications/InvoiceSpecificationsResultMessage.vue